<template>
    <b-taglist>
        <b-tag
            :key="vertical"
            v-for="vertical of verticalsList"
            class="is-clickable"
            :type="`${ (value || currentVertical) !== vertical && !viewOnly ? 'is-gray is-light' : 'is-dark' }`"
            @click.native="setVertical(vertical)">
            <img
                v-if="vertical !== null"
                :src="imageSrc(vertical)"
                class="mr-1"
                :alt="vertical">
            {{ $t(`common.entity.verticals.${ vertical }`) }}
        </b-tag>
    </b-taglist>
</template>

<script>
  import { VerticalsEnum } from "@core/store/types/admin/common/enums/VerticalsEnum";
  import { mapFields } from "@vasiliyrusin/vue-mapfields";
  import {
    GET_USER_CONTEXT_STORAGE,
    UPDATE_CURRENT_VERTICAL
  } from "@core/store/action-constants";
  import { mapGetters, mapMutations, mapState } from "vuex";

  /**
   * Из-за специфики компонента, пришлось разносить логику по разным местам
   * 1. Watch: App.vue
   * 2. Function(setPreferredVertical): auth.ts
   */

  export default {
    name: "VerticalsFilter",

    props: {
      value: {
        type: String,
        default: null
      },
      showCommon: {
        type: Boolean,
        default: false
      },

      // Отключает функционал компонента и оставляет только визуал с одной вертикалью "Нутра"
      // Требуется для улучшения очевидности в разделах, где показывается только нутра
      viewOnly: {
        type: Boolean,
        default: false
      }
    },

    created () {
      this.GET_USER_CONTEXT_STORAGE("filters");
      const { vertical } = this.storageFilters || {};
      const { vertical: currentVertical } = this.$route.query;

      if (vertical && !currentVertical || currentVertical) {
        if (vertical && !currentVertical) {
          this.currentVertical = vertical;
        } else if (currentVertical) {
          this.currentVertical = currentVertical;
        }
      } else if (this.preferredVertical) {
        this.currentVertical = this.preferredVertical;
      } else if (this.viewOnly) {
        this.currentVertical = VerticalsEnum.NUTRA;
      }
    },

    computed: {
      ...mapState({
        preferredVertical: state => state.auth.preferredVertical,
        role: state => state.auth.role
      }),

      ...mapFields("verticals", {
        fields: ["currentVertical"],
        base: "",
        action: UPDATE_CURRENT_VERTICAL
      }),

      ...mapGetters("userContextStorage", ["storageFilters"]),

      ...mapGetters("verticals", ["gamblingOnly", "allVerticals", "nutraOnly"]),

      verticalsList () {
        const verticalsList = Object.values(VerticalsEnum);
        if (this.showCommon) {
          verticalsList.unshift(null);
        }
        if (this.allVerticals && !this.viewOnly) {
          return verticalsList;
        } else if (this.nutraOnly && this.gamblingOnly && !this.viewOnly) {
          return [VerticalsEnum.NUTRA, VerticalsEnum.GAMBLING];
        } else if (this.viewOnly || this.nutraOnly) {
          return [VerticalsEnum.NUTRA];
        } else if (this.gamblingOnly && this.role === "admin") {
          return [VerticalsEnum.GAMBLING];
        }
        return [];
      }
    },

    methods: {
      ...mapMutations("userContextStorage", {
        GET_USER_CONTEXT_STORAGE
      }),
      imageSrc (name) {
        return require(`@/assets/common/${ name.toLowerCase() }.svg`);
      },

      setVertical (vertical) {
        if (this.value) {
          this.$emit("input", vertical);
        } else {
          this.currentVertical = vertical;
        }
        this.$emit("update");
      }
    },

    watch: {
      currentVertical (vertical) {
        this.$router.push({ query: { ...this.$route.query, vertical } }).catch(_ => {});
      }
    }
  };
</script>

<style lang="scss" scoped>
  .tags {
    margin-bottom: 0.1rem !important;
  }
  ::v-deep {
    .tag {
      padding: 1.1rem 0.8rem;
      border-radius: 20px;

      span {
        display: flex;
        align-content: center;

        font-size: .85rem;

        img {
          $size: 20px;

          width: $size;
          height: $size;
        }
      }
    }
  }
</style>